import MobileTable from './mobile_table';
export default {
    curr_data: [],
    selected_column: undefined,
    mobile_table: undefined,
    init() {
        let dropdown = document.getElementById('table_dropdown');
        let table = document.getElementsByClassName('table')[0];
        let that = this;
        
        if(table) {
            //array containing all headers used in tabe.
            let columns = [];

            //getting the table headers e.g. LEAs, Ofsted rating etc.
            let headers = table.getElementsByTagName('th');
            if(headers.length > 0) {

                let la_button = document.getElementById('la-button');
                let text = la_button.getElementsByTagName('P')[0];

                for(let i = 0; i < headers.length; i++) {
                    //adding header text to header array
                    let header_text = headers[i].getElementsByTagName('p')[0].innerHTML;
                    columns.push(header_text);
                }

                //row data is all the data contained in the table cells with which position
                //they were originally in.
                let row_data = {};
                row_data.rows = [];

                //the selected column index.
                for(let i = 0; i < columns.length; i++) {
                    //creating an array for each header object e.g. row_data.Ofsted rating = []
                    row_data[columns[i]] = [];
                }

                console.log("Row Data: ", row_data);

                //getting the data from each row and adding it to the row data.
                let rows = table.getElementsByTagName('tr');
                for(let i = 1; i < rows.length; i++) {
                    //adding a row as a HTML object to easily add later.
                    row_data.rows.push(rows[i]);

                    //for each cell in the row add to the corresponding column data
                    let row_columns = rows[i].getElementsByTagName('td');
                    for(let j = 0; j < row_columns.length; j++) {
                        let object = {id: i - 1};
                        if(j === 0) {
                            object.value = row_columns[j].innerText;
                            row_data[columns[j]].push(object);
                        } else {
                            object.value = parseInt(row_columns[j].innerText);
                            row_data[columns[j]].push(object);
                        }
                    }

                }

                $('#table_dropdown').change((e) => {
                    //sorting the array
                    // let data_copy = row_data.slice(0);
                    let data_copy = jQuery.extend(true, {}, row_data);

                    let dropdown_value = e.target.value.replace(" (low-high)", '');

                    if(dropdown_value === "Local authority") {
                        data_copy["Local authority"].sort(function(a, b) {
                            if(a.value < b.value) { return -1; }
                            if(a.value > b.value) { return 1; }
                        })
                    } else if(dropdown_value === "Overall") {
                        // dropdown_value = "Local authority";
                    } else {
                        data_copy[dropdown_value].sort(function(a, b) {
                            if(isFinite(a.value - b.value)) {
                                return a.value - b.value; 
                            } else {
                                return isFinite(a.value) ? -1 : 1;
                            }
                            // return a.value - b.value;
                        })
                    }

                    this.curr_data = data_copy;
                    this.selected_column = dropdown_value;

                    //if we are on Local authority then 
    
                    console.log("data_copy: ", data_copy[dropdown_value]);
    
                    that.empty_table(rows);

                    if(dropdown_value === "Overall") {
                        dropdown_value = "Local authority";
                    }
                    
                    that.add_rows(data_copy.rows, data_copy[dropdown_value], table);
    
                    console.log("Row Data: ", row_data);
    
                    console.log("Columns", columns);

                    this.reset_la_button();
                    if(MobileTable && window.innerWidth < 768) {
                        MobileTable.get_values(dropdown_value);
                    }
                })

                this.searched_array = [];

                $("#table_input").keyup((e) => {
                    let data_copy;
                    if(this.curr_data && this.selected_column) {
                        data_copy = jQuery.extend(true, {}, this.curr_data);
                    } else {
                        data_copy = jQuery.extend(true, {}, row_data);
                    }

                    let filtered_array = data_copy['Local authority'].filter((word) => {
                        // console.log("Filtering: ", word)
                        if(word.value.toLowerCase().includes(e.target.value.toLowerCase())) {
                            return word
                        }
                    })

                    let ordered_array = [];

                    //re-sort the array to match the selected dropdown
                    if(this.selected_column && this.selected_column !== "Overall") {
                        
                        //make a new array with only the selected items from the filter.
                        for(let i = 0; i < filtered_array.length; i++) {
                            let id = filtered_array[i].id;
                            ordered_array.push(data_copy[this.selected_column].find((row) => {
                                if(row.id === id) {
                                    return row;
                                }
                            }));
                            // ordered_array.push(data_copy[this.selected_column][id]);
                        }

                        if(this.selected_column === "Local authority") {
                            ordered_array.sort(function(a, b) {
                                if(a.value < b.value) { return -1; }
                                if(a.value > b.value) { return 1; }
                            })
                        } else {
                            ordered_array.sort(function(a, b) {
                                if(isFinite(a.value - b.value)) {
                                    return a.value - b.value; 
                                } else {
                                    return isFinite(a.value) ? -1 : 1;
                                }
                                // return a.value - b.value;
                            })
                        }
                    }

                    console.log("Filtered data: ", filtered_array);
                    that.empty_table(rows);

                    if(ordered_array.length > 0) {
                        that.add_rows_search(data_copy.rows, ordered_array, table);
                        this.searched_array = ordered_array;
                    } else {
                        that.add_rows_search(data_copy.rows, filtered_array, table);
                        this.searched_array = filtered_array;
                    }

                    this.reset_la_button();
                    if(MobileTable && window.innerWidth < 768) {
                        if(!this.selected_column) {
                            MobileTable.get_values();
                        } else {
                            MobileTable.get_values(this.selected_column)
                        }
                    }
                })

                let table_input = document.getElementById('table_input');

                la_button.addEventListener('click', (e) => {
                    let data_copy, order_by;
                    if(this.curr_data && this.selected_column) {
                        data_copy = jQuery.extend(true, {}, this.curr_data);
                    } else {
                        data_copy = jQuery.extend(true, {}, row_data);
                    }

                    if(this.selected_column && this.selected_column !== "Overall") {
                        order_by = this.selected_column;
                    } else {
                        order_by = "Local authority";
                    }

                    console.log("User has entered: ", table_input.value);
                    console.log("Local authority clicked");
                    if(table_input.value === '') {
                        if(text.classList.contains('active')) {
                            this.add_rows(data_copy.rows, data_copy[order_by], table);
                        } else {
                            data_copy[order_by].reverse();
                            this.add_rows(data_copy.rows, data_copy[order_by], table);
                        }
                    } else {
                        if(text.classList.contains('active')) {
                            this.add_rows_search(data_copy.rows, this.searched_array, table)
                        } else {
                            var searched_array_copy = this.searched_array.slice();
                            searched_array_copy.reverse();
                            this.add_rows_search(data_copy.rows, searched_array_copy, table);
                        }
                    }

                    this.la_button_switch();
                });
            }
        }

		MobileTable.init();
    },

    la_button_switch() {
        let la_button = document.getElementById('la-button');
        let text = la_button.getElementsByTagName('P')[0];
        if(text.classList.contains('active')) {
            //deactivating the filter.
            text.classList.remove('active');
            text.classList.add('inactive')
        } else {
            text.classList.add('active');
            text.classList.remove('inactive');
        }
    },

    reset_la_button() {
        let la_button = document.getElementById('la-button');
        let text = la_button.getElementsByTagName('P')[0];
        if(text.classList.contains('active')) {
            //deactivating the filter.
            text.classList.remove('active');
            text.classList.add('inactive')
        }
    },

    empty_table(rows) {
        if(rows.length > 0) {
            for(let i = rows.length - 1; i > 0; i--) {
                // console.log("Removing: ", rows[i]);
                rows[i].parentElement.removeChild(rows[i]);
            }
        }
    },

    add_rows(rows, ordered, table) {
        //getting the tbody from the table
        let body = table.getElementsByTagName('tbody')[0];
        if(rows && body) {
            for(let i = 0; i < rows.length; i++) {
                let rows_id = ordered[i].id;
                let row = rows[rows_id];
                console.log("Row ID: " + rows_id + " row: " + row);
                body.appendChild(row);
            }
        }
    },

    add_rows_search(rows, filtered_array, table) {
        let body = table.getElementsByTagName('tbody')[0];
        if(rows && body) {
            for(let i = 0; i < filtered_array.length; i++) {
                let rows_id = filtered_array[i].id;
                let row = rows[rows_id];
                body.appendChild(row);
            }
        }
    }
}